// import * as utils from '@/utils/utils';

import { exportFiles } from '@/utils/utils'
import { Message } from 'antd'
import services from '../services/membertax.js'

const {
  getPaymentList,
  getFilterTypeList,
  getCouierList,
  getPaymentDetail,
  savePayment,
  sendPaymentArrears,
  sendPayment,
  getPaymentCount,
  getPaymentArrearsAount,
  setPaymentSaveExcel,
  setPaymentExport,
  bulkimport,
  getCourierDetail,
  courierUpate,
  saveCourierBatch,
  sendCourier,
  getPaymentYearDetail,
  selectPaymentDetail,
  batchPayConfirmMemUsers,
} = services

const namespace = 'membertax'

export default {
  namespace,
  state: {
    memberServiceDataSource: [],
    paymentList: {}, // 列表数据
    memberTypeList: [], // 会员类型
    enterpriseTypeList: [], // 企业类型
    provinceNameValues: [], // 所在地列表
    couierList: [], // 快递列表
    paymentDetail: {}, // 缴费详情
    paymentCount: '', // 缴费通知数
    courierDetail: {}, // 快递信息
    paymentYear: {},
    selectPaymentDetail: {},
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    *getMemberserviceList({ payload, callback }, { call, put }) {
      const res = yield call(getPaymentList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberServiceDataSource: res.data,
          },
        })
        !!callback && callback(res)
      }
    },
    *getFilterTypeList({ payload }, { call, put }) {
      const res = yield call(getFilterTypeList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberTypeList: res.data.memberTypes,
            enterpriseTypeList: res.data.businessScopes,
            provinceNameValues: res.data.enterpriseTypes,
          },
        })
      }
    },
    // 获取快递列表
    *getCouierList({ payload, callback }, { call, put }) {
      const res = yield call(getCouierList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            couierList: res.data,
          },
        })
        !!callback && callback(res)
      }
    },
    // 欠费通知的统计数
    *getPaymentArrearsAount({ payload, callback }, { call, put }) {
      const res = yield call(getPaymentArrearsAount, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },

    // 根据会员ID查询缴费详情

    // 批量设置缴费未匹配的EXCel导出

    // 缴费通知的统计数
    *getPaymentCount({ payload, callback }, { call, put }) {
      const res = yield call(getPaymentCount, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      }
    },

    // 保存EXCEL 的缴费数据

    // 单独设置缴费
    *getPaymentDetail({ payload, callback }, { call, put }) {
      const res = yield call(getPaymentDetail, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            paymentDetail: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    *savePayment({ payload, callback }, { call, put }) {
      const res = yield call(savePayment, { ...payload })
      if (res && res.success) {
        Message.success('设置缴费成功')
        !!callback && callback(res)
      }
    },

    // 批量发送欠费通知
    *sendPaymentArrears({ payload, callback }, { call, put }) {
      const res = yield call(sendPaymentArrears, { ...payload })
      if (res && res.success) {
        Message.success('发送成功')
        !!callback && callback(res)
      }
    },

    // 批量发送缴费通知
    *sendPayment({ payload, callback }, { call, put }) {
      const res = yield call(sendPayment, { ...payload })
      if (res && res.success) {
        Message.success('发送成功')
        !!callback && callback(res)
      }
    },

    // 保存EXcle缴费设置
    *setPaymentSaveExcel({ payload, callback }, { call, put }) {
      const res = yield call(sendPayment, { ...payload })
      if (res && res.success) {
        Message.success('批量设置成功')
        !!callback && callback(res)
      }
    },

    // 导出结果
    *setPaymentExport({ payload, callback }, { call, put }) {
      const res = yield call(setPaymentExport, { ...payload })
      !!callback && callback(res)
      exportFiles(res, '批量设置缴费未匹配的Excle导出.xlsx')
    },

    // 快递信息-批量上传
    *bulkimport({ payload, callback }, { call, put }) {
      const res = yield call(bulkimport, { ...payload })
    },

    // 快递消息-详情
    *getCourierDetail({ payload, callback }, { call, put }) {
      const res = yield call(getCourierDetail, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            courierDetail: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    // 快递消息更新
    *courierUpate({ payload, callback }, { call, put }) {
      const res = yield call(courierUpate, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
        Message.success('快递更新成功')
      } else {
        Message.error(res.msg)
      }
    },

    // 发送快递
    *sendCourier({ payload, callback }, { call, put }) {
      const res = yield call(sendCourier, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
        Message.success('快递发送成功')
      } else {
        Message.error(res.msg)
      }
    },

    // 快递信息批量保存
    *saveCourierBatch({ payload, callback }, { call, put }) {
      const res = yield call(saveCourierBatch, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
        Message.success('保存成功')
      } else {
        Message.error(res.msg)
      }
    },

    // 清楚快递消息
    *clearDetail({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: {
          courierDetail: {},
        },
      })
    },

    *getPaymentYearDetail({ payload, callback }, { put, call }) {
      const res = yield call(getPaymentYearDetail, payload)
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            paymentYear: res.data,
          },
        })
        callback?.(res)
      }
    },

    *selectPaymentDetail({ payload, callback }, { put, call }) {
      const res = yield call(selectPaymentDetail, payload)
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            selectPaymentDetail: res.data,
          },
        })
        callback?.(res)
      }
    },

    *batchPayConfirmMemUsers({ payload, callback }, { call }) {
      const res = yield call(batchPayConfirmMemUsers, payload)
      if (res && res.success) {
        callback?.(res)
      } else {
        Message.error(res.msg)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
